import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
    uri: "https://cms.idrivesocal.com/graphql",
    cache: new InMemoryCache(),
});

export default client;